module.exports = __webpack_public_path__ + "static/media/siperficie boton copia.0a2fc992.png";